import Footer from './footer.view';

export default Footer;
